import React from "react";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
// import { useAuth } from "./context/authContext";

import UserLayout from "./user/UserLayout";
// import AdminLayout from "./admin/AdminLayout";
import Home from "./user/home/Home";
// import AdminHome from "./admin/home/AdminHome";
import theme from "./theme/theme";
import LoginPage from "./admin/login/LoginPage";

import { AuthProvider } from "./context/authContext";
import Appointment from "./user/Appointment";
// import AdminAppointement from "./components/admin/admin/AdminAppointement";
import Gallery1 from "./components/Gallery1";
import Impressum from "./components/Impressum";
import Datenschutzerklaerung from "./components/Datenschutzerklaerung";

function App() {


  const customTheme = createTheme({
    ...theme,
    palette: {
      ...theme.palette,
      mode: "light",
    },
  });

 

  return (
    <ThemeProvider theme={customTheme}>
      <AuthProvider>
        <CssBaseline />
       
        <div className="App">
          <InnerApp />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

const InnerApp = () => {
  // const { token } = useAuth();
 ;

  return (
    <Routes>
      <Route element={<UserLayout />}>
        <Route path="/" element={<Home />} />
       
        <Route path="/login" element={<LoginPage />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/arbeiten" element={<Gallery1 />} />
        <Route path="/impressum" element={< Impressum/>} />
        <Route path="/datenschutz" element={<Datenschutzerklaerung/>} />



        <Route path="*" element={<Home />} />
      </Route>

      {/* {token && (
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminHome />} />
          <Route path="/admin/available" element={<AdminAppointement />} />



     
           
          <Route path="*" element={<AdminHome />} />
        </Route>
      )} */}
    </Routes>
  );
};
